import client, { Response } from './client';
import { ScheduledOrderSlot } from '../../types/availability';
import { OrderMethod } from '../../types/constants';

export type GetDisabledPreOrderDatesParams = {
  month: number;
  year: number;
  order_method: OrderMethod;
};

export type GetScheduledOrderSlotsParams = {
  date: string;
  order_method: OrderMethod;
  limit?: number;
};

export const loadDisabledPreOrderDates = (
  storeId: string,
  params: GetDisabledPreOrderDatesParams,
): Response<number[]> => client.get(`/stores/${storeId}/disabled-pre-order-dates`, { params });

export const loadScheduledOrderSlots = (
  storeId: string,
  params: GetScheduledOrderSlotsParams,
): Response<ScheduledOrderSlot[]> =>
  client.get(`/stores/${storeId}/scheduled-order-slots`, { params });
